import {
  MDBDropdown,
  MDBDropdownMenu,
  MDBDropdownToggle,
  MDBDropdownItem,
  MDBIcon,
  MDBProgress,
  MDBProgressBar,
} from "mdb-react-ui-kit";
import ExportProgress from './ExportProgress';

const ExportDropdown = ({
  onExport,
  exportLoading = { csvLoading: false, pdfLoading: false },
  exportProgress = { csv: { current: 0, total: 0 }, pdf: { current: 0, total: 0 } },
}) => {
  return (
    <>
      <MDBDropdown>
        <MDBDropdownToggle>
          <MDBIcon fas icon="download" className="me-2" />
          Export
        </MDBDropdownToggle>
        <MDBDropdownMenu>
          <MDBDropdownItem
            link
            onClick={() => onExport("csv")}
            disabled={exportLoading.csvLoading}
          >
            {exportLoading.csvLoading ? (
              <div className="w-100">
                Exporting CSV...
                <MDBProgress height="10" className="mt-2">
                  <MDBProgressBar
                    width={exportProgress.csv.current}
                    valuemin={0}
                    valuemax={exportProgress.csv.total}
                  >
                    {Math.round((exportProgress.csv.current / exportProgress.csv.total) * 100)}%
                  </MDBProgressBar>
                </MDBProgress>
              </div>
            ) : (
              <>
                Excel/CSV
              </>
            )}
          </MDBDropdownItem>

          <MDBDropdownItem
            link
            onClick={() => onExport("pdf")}
            disabled={exportLoading.pdfLoading}
          >
            {exportLoading.pdfLoading ? (
              <div className="w-100">
                Exporting PDF...
                <MDBProgress height="10" className="mt-2">
                  <MDBProgressBar
                    width={exportProgress.pdf.current}
                    valuemin={0}
                    valuemax={exportProgress.pdf.total}
                  >
                    {Math.round((exportProgress.pdf.current / exportProgress.pdf.total) * 100)}%
                  </MDBProgressBar>
                </MDBProgress>
              </div>
            ) : (
              <>
                Print/PDF
              </>
            )}
          </MDBDropdownItem>
        </MDBDropdownMenu>
      </MDBDropdown>

      {exportLoading.csvLoading && (
        <ExportProgress 
          title="Preparing CSV Export" 
          progress={exportProgress.csv}
        />
      )}
      
      {exportLoading.pdfLoading && (
        <ExportProgress 
          title="Preparing PDF Export" 
          progress={exportProgress.pdf}
        />
      )}
    </>
  );
};

export default ExportDropdown;
